import { Loading } from 'components/loading/Loading';
import CustomLink from 'components/TableLink';
import _ from 'lodash';
import React, { useEffect, useState } from 'react';
import { fetchRouteDetail, fetchRouteOrders } from 'services';
import { showError, stringifyAndParseObj } from 'utils';
import styles from './index.module.scss';
import OrderProduct from './orderProduct';

const RouteOrders = (props) => {
  const { id: routeId } = props.match.params;

  const [loading, setLoading] = useState<boolean>(true);
  const [routeOrders, setRouteOrders] = useState<Record<string, any>[]>([]);


  const fetchRouteOrdersFn = async () => {
    try {
      let [route, response] = await Promise.all([
        fetchRouteDetail(routeId),
        fetchRouteOrders({ id: routeId }),
      ]);
      const { route: routeDetails = {}} = route;
      response = stringifyAndParseObj(response);
      response = response?.map((order)=>{
        return {
          ...order,
          index: routeDetails?.routingOrder[order.objectId],
        };
      });
      response = _.orderBy(response, ['index'],['asc']);
      setRouteOrders(response);
    } catch (e) {
      showError(e);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchRouteOrdersFn();
  }, []);

  if (loading) return <Loading />;

  const getHeader = () => (
    <div className={styles['header']}>
      <div className={styles['heading']}>Route Orders</div>
    </div>
  );

  const getOrderDetail = (params) => {
    const { key, value } = params;
    if (!value) return null;
    return (
      <div className={styles['detail-container']}>
        <span className={styles['key']}>{key}:</span> {value}
      </div>
    );
  };

  const getOrderItems = (order) => {
    return order?.orderItems?.map((orderItem, i) => {
      return <OrderProduct orderItem={orderItem} key={i} />;
    });
  };

  const getGoogleMapLink = (googleMapURL) => {
    return (
      <div className={styles['detail-container']}>
        <a className={styles['google-map']} href={googleMapURL} target="_blank" rel="noreferrer">
          Google Map
        </a>
      </div>
    );
  };

  const orderCard = (order) => {
    return (
      <div className={`col-12 col-md-4 ${styles['order-container']}`}>
        <div className={styles['detail-container']}>
          <span className={styles['key']}>OrderId:</span> <CustomLink text={order?.objectId} linkTo={`/orders/${order?.objectId}`} />
        </div>
        {getOrderDetail({ key: 'Name', value: order?.user?.full_name })}
        {getOrderDetail({ key: 'Phone', value: order?.user?.phone })}
        {getOrderDetail({
          key: 'Address',
          value: order?.addressObject?.address,
        })}
        {getGoogleMapLink(order?.googleMapURL)}
        <div className={styles['heading']}>
          Order Items({order?.orderItems?.length}):
        </div>
        {getOrderItems(order)}
      </div>
    );
  };

  return (
    <>
      {getHeader()}
      <div id={'main-container'} className={`${styles['main-container']}`}>
        <div className={`container-fluid ${styles['orders']}`}>
          {routeOrders?.map(orderCard)}
        </div>
      </div>
    </>
  );
};

export { RouteOrders };
